import {
  useProcessingRuleById,
  useProcessingRulesPagination,
} from '@/modules/ProcessingDefinition/ProcessingRule/hooks';

interface UseProcessingRulesDataProps {
  currentProcessingRuleName?: string;
  processingRuleSourceId?: string;
  parentTemplate?: string;
}

export const useProcessingRulesData = ({
  currentProcessingRuleName,
  processingRuleSourceId,
  parentTemplate,
}: UseProcessingRulesDataProps) => {
  const { processingRulesList, isLoadingRules, isFieldLoading, handleLoadMoreRules, resetPagination } =
    useProcessingRulesPagination({
      isUsed: !!parentTemplate,
      mergeRuleId: processingRuleSourceId,
    });

  const { rule: currentRule, isLoading: isLoadingCurrentRule } =
    useProcessingRuleById(currentProcessingRuleName);

  return {
    currentRule,
    isLoadingCurrentRule,
    processingRulesList,
    isLoadingRules,
    isFieldLoading,
    handleLoadMoreRules,
    resetPagination,
  };
};
